// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"94":"4db6ea6f395a2e620668","663":"2812c048123e88c23a6a"}[chunkId] + ".js";
};